import './InfoArea.css';
import RichTextRenderer from "../utils/RichTextRenderer";

// InfoArea component to display content

function InfoArea( {title, value, icon} ) {

    return(
        <div className="InfoArea">
            <div className="InfoArea-icon">{icon}</div>            
            <div className="InfoArea-content">
                <div className="InfoArea-title">{title}</div>
                <div className="InfoArea-text">
                    <RichTextRenderer value={value} />
                </div>
            </div>
        </div>
    )
}

export default InfoArea;